import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Input, Modal, AddAlert } from '../../../components'
import { modalClose, verificaConsumoConta } from '../../../layout/redux/layoutActions'
import { calculadoraCompraDeAtivos, CheckoutAtivosAvulsosXD, listarAtivos, setAtivos } from '../redux/minhasAssinaturasActions'

import { PopoverCentralAjuda } from '../../../components/popovercentralajuda/popovercentralajuda'


export default () => {
  const dispatch = useDispatch()
  const { sistema, device, usuario, statusModal } = useSelector(state => state.layoutState)
  const { ativos, avaliacoes, assinatura } = useSelector(state=> state.minhasAssinaturasState)
  const nls = require(`../nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`)

  const nlsContexto = require(`../../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  const idarray = [116];



  useEffect(() => {
    if (statusModal === 'assinaturas-adquirir-ativos') {
      dispatch(verificaConsumoConta())
    }
  }, [statusModal])

  
  useEffect(()=> {
    if (statusModal === 'assinaturas-adquirir-ativos' && sistema.consumoConta) {     
      dispatch(listarAtivos({consumoConta: sistema.consumoConta, moeda: sistema.moeda, tipo: '', status: 'vazio', idioma: sistema.idiomaIdValue}))
    }
  }, [statusModal, sistema.idioma, sistema.consumoConta])

  const handleChange = e => {
    const listaAtivos = ativos.map(a=> a.id === e.id ? {...a, ...e} : a )
    dispatch(setAtivos(e))
    dispatch(calculadoraCompraDeAtivos({ativos: listaAtivos}))
  }

  const handleCancelar = e => {
    dispatch(modalClose())
  }
  
  const handleSalvar = e => {
    console.warn(e, 'assinaturas-adquirir-ativos');
    const hasAtivos = ativos.filter(a=> a.quantidadeDesejada > 0)
    const params = {
      moeda: usuario.moedaIso4217,
      ativos: [...ativos, {
        descricao: "Avaliações mensais",
        id: 6,
        quantidadeDesejada: avaliacoes.somaQuantidadeQueriesSemQueryPura30,
        valor: avaliacoes.somaQuantidadeQueriesSemQueryPura30
      }]

    }
    if (hasAtivos.length) {
      dispatch(CheckoutAtivosAvulsosXD(params, nlsPopup))
    } else {
      dispatch( AddAlert('danger', nls.adicioneativos))
    }
  }
  
  console.log(avaliacoes, 'avaliacoes');
  
  return (
    <Modal
      name='assinaturas-adquirir-ativos'     

      title={
        <span style={{ display: 'inline', whiteSpace: device !== 'desktop' ? 'normal' : 'nowrap' }}>
          {nls[false? 'titleAlterarAtivos' : 'titleAdquirirAtivos']}
          <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray} />
        </span>
      }     
      open={statusModal === 'assinaturas-adquirir-ativos' ? true : false}
      close={() => handleCancelar()}
      closeText={nls.btnFechar}
      actions={<>
        <Button
          color='default'
          onClick={()=> handleCancelar()}
        >{nls.cancelar}</Button>
        <Button
          color='primary'
          onClick={()=> handleSalvar({})}
        >{nls[false? 'editarAtivos' : 'salvarAtivos']}</Button>
      </>}

    >
      <div>
        <div className='ativos-lista-title'>
          <h5>{nls.adicionarAtivos}</h5>
        </div>
        <div className='ativos-lista'>
          {ativos.map(e=> {
            const min = 0
            const max = 1000
            return <div key={e.id} className='ativos-lista-item'>
              <div className='ativos-lista-item-info'>
                <strong>{e.descricao}</strong>
                <small>{nls.valorAtual}: {e.valor}</small>
              </div>
              <div className='ativos-lista-item-input'>
                  <Input 
                    type='number'
                    value={e.quantidadeDesejada}
                    action={a=> handleChange({...e, quantidadeDesejada: a.value})}
                    min={min}
                    max={max}
                  />
              </div>
            </div>
          })}
          <div className='ativos-lista-item'>
            <div className='ativos-lista-item-info'>
              <strong>{nls.avaliacoesMensaisAdicionais}</strong>
              <small>{nls.valorAtual}: {usuario?.avaliacoesPermitidasConta}</small>
            </div>
            <div className='ativos-lista-item-input'>
              <div className='flag-primary'>
                {avaliacoes.somaQuantidadeQueriesSemQueryPura30}
              </div>
            </div>
          </div>
        </div>
        <div className='ativos-info'>
          <span>{nls.valorCobradoImediatamente}: <strong>{avaliacoes.valorAdicional}</strong> </span>
          {!(assinatura.statusId === 'SAA' || assinatura.statusId === 'SAC') ? 
            <span>{nls.valorCobradoProxima}: <strong>{avaliacoes.valorTotal}</strong> </span>
          :null}
        </div>
      </div>
    </Modal>
  )
}
